import React from 'react';
import { Check } from 'lucide-react';

interface ProgressIndicatorProps {
  currentStep: number;
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({ currentStep }) => {
  return (
    <div className="flex items-center justify-center mb-2 sm:mb-4 px-2 sm:px-4">
      <div className="flex items-center scale-75 sm:scale-90 md:scale-100">
        <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-medium ${(currentStep === 1) ? 'bg-blue-600 text-white' : (currentStep > 1) ? 'bg-custom-500' : 'bg-gray-200 text-gray-600'} flex items-center justify-center text-xs sm:text-sm font-medium`}>
          {currentStep > 1 ? <Check className="size-3 sm:size-4" /> : 1}
        </div>
        <span className="ml-1 sm:ml-2 text-xs sm:text-sm text-gray-600 hidden sm:inline">Setup</span>
      </div>
      <div className="w-6 sm:w-12 h-px bg-gray-300 mx-2 sm:mx-4"></div>
      <div className="flex items-center scale-75 sm:scale-90 md:scale-100">
        <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-medium ${(currentStep === 2) ? 'bg-blue-600 text-white' : (currentStep > 2) ? 'bg-custom-500' : 'bg-gray-200 text-gray-600'} flex items-center justify-center text-xs sm:text-sm font-medium`}>
          {currentStep > 2 ? <Check className="size-3 sm:size-4" /> : 2}
        </div>
        <span className="ml-1 sm:ml-2 text-xs sm:text-sm text-gray-600 hidden sm:inline">Review</span>
      </div>
      <div className="w-6 sm:w-12 h-px bg-gray-300 mx-2 sm:mx-4"></div>
      <div className="flex items-center scale-75 sm:scale-90 md:scale-100">
        <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-medium ${(currentStep === 3) ? 'bg-blue-600 text-white' : (currentStep > 3) ? 'bg-custom-500' : 'bg-gray-200 text-gray-600'} flex items-center justify-center text-xs sm:text-sm font-medium`}>
          {currentStep > 3 ? <Check className="size-3 sm:size-4" /> : 3}
        </div>
        <span className="ml-1 sm:ml-2 text-xs sm:text-sm text-gray-600 hidden sm:inline">Contact</span>
      </div>
      <div className="w-6 sm:w-12 h-px bg-gray-300 mx-2 sm:mx-4"></div>
      <div className="flex items-center scale-75 sm:scale-90 md:scale-100">
        <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-medium ${(currentStep === 4) ? 'bg-blue-600 text-white' : (currentStep > 4) ? 'bg-custom-500' : 'bg-gray-200 text-gray-600'} flex items-center justify-center text-xs sm:text-sm font-medium`}>
          {currentStep > 4 ? <Check className="size-3 sm:size-4" /> : 4}
        </div>
        <span className="ml-1 sm:ml-2 text-xs sm:text-sm text-gray-600 hidden sm:inline">Confirm</span>
      </div>
    </div>
  );
};

export default ProgressIndicator;
